// extracted by mini-css-extract-plugin
export default {"container":"center_container__QSHPJ"};